module.exports = __webpack_public_path__ + "static/media/ic_engine.4ed4b144.svg";